import { Show, ArrayField, Datagrid, DateField, TextField, SimpleShowLayout, BooleanField } from "react-admin";

import { Typography, Grid } from "@mui/material";

const ShowVersionObject = ({ mode }) => {
  let title;
  let isPage;

  switch (mode) {
    case "page":
      title = "Детайли за страница";
      isPage = true;
      break;
    case "component":
      title = "Детайли за компонент";
      isPage = false;
      break;
    default:
  }

  return (
    <Show title={title}>
      <Grid
        container
        spacing={5}
      >
        <Grid
          item
          xs={12}
          sm={5}
          lg={4}
        >
          <SimpleShowLayout>
            <TextField
              disabled
              source="id"
              fullWidth
            />
            <TextField
              source="name"
              label="Име"
              fullWidth
            />
            {isPage && (
              <TextField
                source="route"
                label="Адрес"
              />
            )}
            {isPage && (
              <BooleanField
                source="isInternal"
                label="Вътрешен път?"
              />
            )}
            <TextField
              source="activeVersionId"
              label="Текуща(активна) весия"
            />
            <TextField
              source="futureActiveVersion.id"
              label="Бъдеща версия"
              emptyText="Няма зададена"
            />
            <DateField
              source="futureActiveVersion.activeFrom"
              label="Начална дата на бъдеща версия"
              emptyText="Няма зададена"
              showTime
            />

            <ArrayField
              source="temporaryVersions"
              label="Временни версии"
              fullWidth
            >
              <Datagrid
                bulkActionButtons={false}
                empty={<Typography sx={{ fontSize: ".8rem" }}>Няма зададени</Typography>}
              >
                <TextField
                  source="id"
                  label="Версия"
                />
                <DateField
                  showTime
                  source="activeFrom"
                  label="Активна от"
                  fullWidth
                />
                <DateField
                  showTime
                  source="activeTo"
                  label="Активна до"
                  fullWidth
                />
              </Datagrid>
            </ArrayField>
            {isPage && (
              <TextField
                source="language"
                label="Език"
              />
            )}
          </SimpleShowLayout>
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          lg={8}
        >
          <SimpleShowLayout>
            <ArrayField
              source="versions"
              label="Версии"
              emptyText="Няма налични версии"
            >
              <Datagrid
                bulkActionButtons={false}
                empty={<Typography>Няма налични версии</Typography>}
              >
                <TextField source="id" />
                <TextField
                  label="Име"
                  source="name"
                  emptyText="Няма зададен"
                />
                <DateField
                  label="Създадена на"
                  source="createdAt"
                  showTime
                />
                <TextField
                  source="user"
                  label="Потребител"
                />
                <BooleanField source="isDraft" />
              </Datagrid>
            </ArrayField>
          </SimpleShowLayout>
        </Grid>
      </Grid>
    </Show>
  );
};

export default ShowVersionObject;
